/**
 * The validation verdict stored against a submitted list. Captured on the registrant's device at
 * submit time, where a hydrated and freshly validated force is already in hand, and overwritten
 * when an organiser re-checks. Never derived from a force's own stored validationErrors — see
 * force.service.ts:252-260 for why those are unsafe to treat as ground truth.
 */
export interface ListValidationSummary {
    errors: number;
    warnings: number;
    checkedAt: string;
    appVersion: string;
}

export function summariseValidation(
    validationErrors: { type: string }[] | undefined,
    appVersion: string,
    now: Date = new Date()
): ListValidationSummary {
    const all = validationErrors ?? [];
    return {
        errors: all.filter((e) => e.type === 'Error').length,
        warnings: all.filter((e) => e.type === 'Warning').length,
        checkedAt: now.toISOString(),
        appVersion
    };
}
